import { render, staticRenderFns } from "./DispatchLoad.vue?vue&type=template&id=6950539c&scoped=true"
import script from "./DispatchLoad.vue?vue&type=script&lang=js"
export * from "./DispatchLoad.vue?vue&type=script&lang=js"
import style0 from "./DispatchLoad.vue?vue&type=style&index=0&id=6950539c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950539c",
  null
  
)

export default component.exports